import React, { useContext } from "react";
import { ThemeContext } from "styled-components";
import { Box } from "@bca/ui-library";

import StyledIcon from "../Interfaces/StyledIcon";

const LocationPinSVG: React.FunctionComponent<StyledIcon> = ({
  fill = "primary-navy-blue",
  ...props
}) => {
  const theme = useContext(ThemeContext);
  const hexColor = theme.colors[fill] || fill;
  return (
    <Box {...props}>
      <title>Location Pin Icon</title>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="14"
        height="18"
        viewBox="0 0 14 18"
        fill="none"
      >
        <path
          d="M6.27083 17.6278C6.59896 18.1241 7.36458 18.1241 7.69271 17.6278C13.0156 10.1835 14 9.57128 14 6.80624C14 3.04863 10.8646 0 7 0C3.09896 0 0 3.04863 0 6.80624C0 9.57128 0.947917 10.1835 6.27083 17.6278ZM7 9.64217C5.35938 9.64217 4.08333 8.40145 4.08333 6.80624C4.08333 5.24648 5.35938 3.97031 7 3.97031C8.60417 3.97031 9.91667 5.24648 9.91667 6.80624C9.91667 8.40145 8.60417 9.64217 7 9.64217Z"
          fill={hexColor}
        />
      </svg>
    </Box>
  );
};

export default LocationPinSVG;
